import { useState, useEffect } from 'react';

export function useSimplePossessionsFilter(report) {
  const [possessions, setPossessions] = useState({});
  const bounds = getBoundsFromReport(report);

  // set the value the first time the summary is loaded
  useEffect(() => {
    if (!possessions && report && report.bounds) {
      setPossessions(getBoundsFromReport(report));
    }
    if (!possessions && bounds) {
      setPossessions(bounds);
    }
  }, [possessions, report, bounds]);

  const onChange = value => {
    setPossessions({ min: value.min, max: value.max });
  };

  if (possessions && bounds) {
    if (possessions.min < bounds.min) {
      possessions.min = bounds.min;
    }
    if (possessions.max > bounds.max) {
      possessions.max = bounds.max;
    }
  }

  return { possessions, bounds, onChange };
}

function getBoundsFromReport(report) {
  return (
    report.bounds && {
      min: Math.floor(report.bounds.min),
      max: Math.floor(report.bounds.max) + 1,
    }
  );
}
